import './homeCategories.css'
import { motion } from 'framer-motion'
import plants from '../../../assets/cat-plant2.png'
import pots from '../../../assets/cat-pots2.png'
import stones from '../../../assets/cat-stones.png'
import { useNavigate } from 'react-router-dom'

export default function HomeCategoriesMobile() {
    const Categories = [
        { id: 1, name: "Plants", img: plants, imgClass: "img-plant", href: '/plants-Categorie' },
        { id: 2, name: "Pots", img: pots, imgClass: "img-pots", href: '/' },
        { id: 3, name: "Stones", img: stones, imgClass: "img-stone", href: '/' }
    ]
    const navigate = useNavigate();
    return (
        <>
            <h2 className="about-us-title" style={{ fontSize: '1.5rem' }}>Categories</h2>
            <div className="categories-container" style={{ display: "grid", gap: "4rem" }}>
                {Categories.map((product) => (
                    <div key={product.id} className="category-wrapper" onClick={() => navigate(product.href)}
                        style={{ cursor: "pointer" }}>
                        <div className="category-container">
                            {product.img && (
                                <motion.img
                                    src={product.img}
                                    alt={product.name}
                                    className={product.imgClass}
                                    animate={{
                                        y: [0, -15, 0]
                                    }}
                                    transition={{
                                        duration: 5,
                                        repeat: Infinity,
                                        ease: "easeInOut"
                                    }}
                                />
                            )}
                        </div>
                        <div
                            onClick={() => navigate('/plants-Categorie')}
                            style={{ cursor: "pointer" }}
                        >
                            <p className="category-name"  >{product.name}</p>
                        </div>

                    </div>
                ))}
            </div>
        </>
    )
}
